/**
 * Third-party entry CFOP helper (request 0206 / spec 0044 §5).
 *
 * Pure, no I/O. `thirdPartyEntryCfops` is a free-text org param (comma/semicolon separated —
 * there is no `list` org-param type, see 0206 §1.1) that names the CFOPs that mark an invoice
 * item as third-party (industrialização por encomenda) material entering the ledger with an
 * owner instead of as own stock.
 */
/** Strip everything but digits — `1.901`, `1901`, ` 1901 ` all normalize to `"1901"`. */
function normalizeCfop(raw) {
    return raw.replace(/\D/g, '');
}
/**
 * Parse the org param's free text into a normalized list of CFOP codes.
 * Splits on comma or semicolon; drops empties after normalization.
 */
export function parseThirdPartyCfops(raw) {
    if (typeof raw !== 'string' || !raw.trim())
        return [];
    return raw
        .split(/[,;]/)
        .map((part) => normalizeCfop(part))
        .filter((part) => part.length > 0);
}
/**
 * Whether `cfop` is in the (already normalized) third-party list.
 * Empty list ⇒ always `false` — the non-regression default for every org that has not
 * configured this yet (0206 §5 criterion 1). Exact match only — no prefix, no range.
 */
export function isThirdPartyCfop(cfop, list) {
    if (!cfop)
        return false;
    if (list.length === 0)
        return false;
    const normalized = normalizeCfop(cfop);
    if (!normalized)
        return false;
    return list.includes(normalized);
}
//# sourceMappingURL=thirdPartyCfop.js.map